import { ContainerModule } from '@patsnap/tahiti-core/shared/inversify'
import { EntityCardApi, EntityCardApiImpl } from './apis/entity-card-api'

export const entityCardContainer = new ContainerModule((bind) => {
    bind(EntityCardApi).to(EntityCardApiImpl)
})
